import { render, staticRenderFns } from "./publiceTc.vue?vue&type=template&id=9420f664&scoped=true&"
import script from "./publiceTc.vue?vue&type=script&lang=js&"
export * from "./publiceTc.vue?vue&type=script&lang=js&"
import style0 from "./publiceTc.vue?vue&type=style&index=0&id=9420f664&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9420f664",
  null
  
)

export default component.exports